import { ArcAuthConfig } from '@arcauth/react-sdk';

export const configMap: { [key: string]: { clientID: string; serverUrl: string; redirectUri: string } } = {
  // ARCHIVES
    '086648b5-3e54-4622-917c-62936d02983a': {
      clientID: '086648b5-3e54-4622-917c-62936d02983a', // The client ID of your ArcAuth application, e.g.,
      // serverUrl: 'http://10.10.85.46:30000/tokenexchange', // The URL of your server that performs the token exchange
      serverUrl: 'https://stgauthtoken.arcfacilities.com/tokenexchange',
      redirectUri: 'https://stgprofile.skysite.com', // Where to redirect to your React client after authentication
      //redirectUri: 'http://localhost:5000',
    },
  // SBB
  '086648b5-3e54-4622-917c-62936d02982a': {
    clientID: '086648b5-3e54-4622-917c-62936d02982a',
    serverUrl: 'https://stgauthtoken.arcfacilities.com/tokenexchange',
    redirectUri: 'http://localhost:5000',
  },
  // FACILITIES
    'd69c6394-60cb-44fb-b8be-f57776d8a14e': {
      clientID: 'd69c6394-60cb-44fb-b8be-f57776d8a14e',
      // serverUrl: 'http://10.10.85.46:30000/falocaltoken',
      serverUrl: 'https://stgauthtoken.arcfacilities.com/tokenexchange',
      redirectUri: 'https://stgprofile.arcfacilities.com',
      //redirectUri: 'http://localhost:5000',
    },
    // add more configurations as needed...
  };
  


export function getConfig(clientID: string): ArcAuthConfig {
  return configMap[clientID];
}